import { ZoneFeature, Zones } from '../models/zones-base-interfaces';
import { authFetchGET } from '../utils/auth-fetch';

const env = (<any>window).appenv.services.geofences;

export class GeofencesService {
    static async fetchGeofences(): Promise<Zones> {
        return await authFetchGET(env.scope, `${env.baseurl}/geofences`);
    }

    static async fetchGeofencesByTerminalId(terminalId: string): Promise<Zones> {
        return await authFetchGET(env.scope, `${env.baseurl}/geofences/${terminalId}`)
    }
}